var _rect, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgImage(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 50,
    rx: 10,
    fill: "#EAEAE6"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2332_104659)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.5314 15.438C20.6357 15.2815 20.8114 15.1875 20.9995 15.1875H26.9995C27.1875 15.1875 27.3632 15.2815 27.4675 15.438L28.8005 17.4375H31.5C32.047 17.4375 32.5716 17.6548 32.9584 18.0416C33.3452 18.4284 33.5625 18.953 33.5625 19.5V30C33.5625 30.547 33.3452 31.0716 32.9584 31.4584C32.5716 31.8452 32.047 32.0625 31.5 32.0625H16.5C15.953 32.0625 15.4284 31.8452 15.0416 31.4584C14.6548 31.0716 14.4375 30.547 14.4375 30L14.4375 19.5C14.4375 18.953 14.6548 18.4284 15.0416 18.0416C15.4284 17.6548 15.953 17.4375 16.5 17.4375H19.1984L20.5314 15.438ZM21.3005 16.3125L19.9675 18.312C19.8632 18.4685 19.6875 18.5625 19.4995 18.5625H16.5C16.2514 18.5625 16.0129 18.6613 15.8371 18.8371C15.6613 19.0129 15.5625 19.2514 15.5625 19.5L15.5625 30C15.5625 30.2486 15.6613 30.4871 15.8371 30.6629C16.0129 30.8387 16.2514 30.9375 16.5 30.9375L31.5 30.9375C31.7486 30.9375 31.9871 30.8387 32.1629 30.6629C32.3387 30.4871 32.4375 30.2486 32.4375 30V19.5C32.4375 19.2514 32.3387 19.0129 32.1629 18.8371C31.9871 18.6613 31.7486 18.5625 31.5 18.5625H28.4995C28.3114 18.5625 28.1357 18.4685 28.0314 18.312L26.6984 16.3125L21.3005 16.3125Z",
    fill: "#858479"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24 21.5625C22.4467 21.5625 21.1875 22.8217 21.1875 24.375C21.1875 25.9283 22.4467 27.1875 24 27.1875C25.5533 27.1875 26.8125 25.9283 26.8125 24.375C26.8125 22.8217 25.5533 21.5625 24 21.5625ZM20.0625 24.375C20.0625 22.2004 21.8254 20.4375 24 20.4375C26.1746 20.4375 27.9375 22.2004 27.9375 24.375C27.9375 26.5496 26.1746 28.3125 24 28.3125C21.8254 28.3125 20.0625 26.5496 20.0625 24.375Z",
    fill: "#858479"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2332_104659"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(12 12)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImage);
export default __webpack_public_path__ + "static/media/image.ebe62fd73a5a36e1ce3e3d11ce5442ef.svg";
export { ForwardRef as ReactComponent };